<template>
  <div class="teaching-score-input-detail">
    <div class="header">
      <NavBar :title="barTitle"
              border
              @back="hidePopover">
      </NavBar>
    </div>
    <div class="main">
      <div class="main-cont">
        <TeachingScoreInputDetailMain :schedule-id="rowData.id"
                                      v-bind="$attrs"
                                      v-on="$listeners"></TeachingScoreInputDetailMain>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '../../../../../../../widgets/NavBar'
import TeachingScoreInputDetailMain from './main'
export default {
  name: 'TeachingScoreInputDetail',
  components: {
    NavBar,
    TeachingScoreInputDetailMain
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  computed: {
    barTitle () {
      return `${this.rowData.semesterName} - ${this.rowData.className} - ${this.rowData.siteName} - ${this.rowData.courseName}`
    }
  },
  methods: {
    hidePopover () {
      this.$emit('hidePopover')
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-input-detail {
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
